module.exports = "/images/vendor/vue-paycard/src/visaelectron.png?cac83318d8837de3e4ec556db2a44dd5";